<lx-form-field-selector
  [label]="label"
  [disabled]="disabled"
  [value]="value"
  valueExpr="code"
  [itemList]="itemList"
  [buttonView]="buttonView"
  [placeholder]="placeholder"
  [isOpen]="isOpen"
  [autofill]="true"
  (valueChange)="valueChange.emit($event)"
  (itemChange)="itemChange.emit($event)"
></lx-form-field-selector>
